<div class="container" [class.ch-light-theme]="!isDarkMode()">
  <!-- Premium Modern Sub-Header Navigation -->
  <div class="reports-sub-header">
    <div class="sub-header-left">
      <div class="sub-header-title-group">
        <div class="sub-header-icon-box">
          <mat-icon>assessment</mat-icon>
        </div>
        <div class="sub-header-text">
          <h2 class="sub-header-title">Reports</h2>
          <span class="sub-header-subtitle">Access and review Heatplan Logs and Final Voyage Reports</span>
        </div>
      </div>
    </div>

    <!-- Segmented Sub-Navigation Tabs -->
    <div class="reports-segmented-tabs" role="tablist">
      <a routerLink="/ch-reportTable" role="tab" class="report-subtab-btn"
        [class.active]="activeReportTab === 'heat-plans'" [attr.aria-selected]="activeReportTab === 'heat-plans'">
        <mat-icon class="subtab-icon">table_chart</mat-icon>
        <span class="subtab-label">Heatplan Reports</span>
      </a>

      <a routerLink="/ch-finalReport" role="tab" class="report-subtab-btn"
        [class.active]="activeReportTab === 'final-reports'" [attr.aria-selected]="activeReportTab === 'final-reports'">
        <mat-icon class="subtab-icon">description</mat-icon>
        <span class="subtab-label">Final Report</span>
      </a>
    </div>
  </div>

  <div class="action-header-container" #filterContainer>
    <div class="modern-action-bar">
      <div class="right-filters">
        <form [formGroup]="myreportForm" class="filter-fields">

          <!-- VESSEL MULTI-SELECT -->
          <div class="compact-multi-select">
            <div class="select-box" [class.has-selection]="selectedVessels.length > 0"
              [class.is-open]="vesselDropdownOpen" (click)="toggleVesselDropdown($event)">
              <div class="box-content-left">
                <mat-icon class="filter-type-icon vessel-icon">directions_boat</mat-icon>
                <span class="box-label" [title]="selectedVessels.join(', ')">{{ selectedVessels.length ?
                  (selectedVessels.length === vesselOptions.length ? 'All Vessels'
                  : (selectedVessels.length === 1 ? selectedVessels[0] : selectedVessels.length + ' Vessels')) :
                  'Select Vessel' }}</span>
              </div>
              <div class="box-content-right">
                <span class="selection-pill"
                  *ngIf="selectedVessels.length > 0 && selectedVessels.length < vesselOptions.length">{{
                  selectedVessels.length }}</span>
                <mat-icon class="clear-filter-btn" *ngIf="selectedVessels.length > 0"
                  (click)="clearVesselFilter($event)" title="Clear Vessel Filter">close</mat-icon>
                <mat-icon class="dropdown-arrow">expand_more</mat-icon>
              </div>
            </div>
            <div class="dropdown-panel" *ngIf="vesselDropdownOpen" (click)="$event.stopPropagation()">
              <div class="panel-header">
                <div class="search-container">
                  <mat-icon class="search-icon">search</mat-icon>
                  <input type="text" placeholder="Search Vessel..."
                    (input)="vesselSearchQuery = $any($event.target).value" [value]="vesselSearchQuery">
                  <mat-icon class="search-clear" *ngIf="vesselSearchQuery"
                    (click)="vesselSearchQuery = ''">close</mat-icon>
                </div>
                <div class="quick-toggle-bar">
                  <label class="all-option" (click)="$event.stopPropagation()">
                    <input type="checkbox" (change)="toggleAllVessels($event)"
                      [checked]="isAllVesselsSelected()">
                    <span class="checkbox-custom"></span>
                    <span class="all-label">Select All</span>
                  </label>
                  <span class="selection-status-text">{{ selectedVessels.length }} of {{ vesselOptions.length }}</span>
                </div>
              </div>
              <div class="options-list">
                <label class="option" *ngFor="let vessel of getFilteredVessels()"
                  [class.selected]="selectedVessels.includes(vessel)">
                  <input type="checkbox" (change)="onVesselCheckboxChange($event, vessel)"
                    [checked]="selectedVessels.includes(vessel)">
                  <span class="checkbox-custom"></span>
                  <span class="option-name">{{ vessel }}</span>
                </label>
                <div class="no-options-found" *ngIf="getFilteredVessels().length === 0">
                  <mat-icon>search_off</mat-icon>
                  <span>No vessels found</span>
                </div>
              </div>
            </div>
          </div>

          <!-- MODERN DATE RANGE PICKER -->
          <div class="modern-date-range-picker"
            [class.has-value]="myreportForm.get('from_date')?.value || myreportForm.get('to_date')?.value"
            (click)="rangePicker.open()">
            <mat-icon class="calendar-prefix-icon">calendar_month</mat-icon>
            <mat-date-range-input [formGroup]="myreportForm" [rangePicker]="rangePicker" class="date-range-input-wrap">
              <input matStartDate formControlName="from_date" placeholder="From" readonly (click)="rangePicker.open()"
                (dateChange)="filterClick()">
              <span class="range-arrow">→</span>
              <input matEndDate formControlName="to_date" placeholder="To" readonly (click)="rangePicker.open()"
                (dateChange)="filterClick()">
            </mat-date-range-input>

            <div class="clear-date-btn"
              *ngIf="myreportForm.get('from_date')?.value || myreportForm.get('to_date')?.value"
              title="Clear Date Range" (click)="clearDateFilter($event)">
              <mat-icon class="clear-date-icon">close</mat-icon>
            </div>

            <!-- Tooltip info matching cargo heating -->
            <mat-icon class="info-icon date-info-icon" (click)="$event.stopPropagation()"
              matTooltip="ℹ️ Filter by Reported Timestamp"
              matTooltipClass="custom-modern-tooltip" matTooltipPosition="above">info_outline</mat-icon>

            <mat-datepicker-toggle matIconSuffix [for]="rangePicker"
              (click)="$event.stopPropagation()"></mat-datepicker-toggle>
            <mat-date-range-picker #rangePicker>
              <mat-date-range-picker-actions>
                <button mat-button matDateRangePickerCancel>Cancel</button>
                <button mat-raised-button color="primary" matDateRangePickerApply
                  (click)="filterClick()">Apply</button>
              </mat-date-range-picker-actions>
            </mat-date-range-picker>
          </div>

          <!-- ACTIONS -->
          <div class="filter-action-btns">
            <button type="button" class="icon-btn clear-all-btn" [class.has-active]="hasActiveFilters()"
              (click)="clearClick()" title="Reset Filters">
              <mat-icon>restart_alt</mat-icon>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <app-ch-skeleton *ngIf="isLoading" variant="table" [rows]="8" [cols]="8"></app-ch-skeleton>

  <!-- UNIFIED MODERN TABLE CARD -->
  <div class="reports-table-card" *ngIf="!isLoading" [ngClass]="{ 'dark-card': isDarkMode() }">
    <div class="table-scroll-container scroll-bar" [ngClass]="{ 'dark-table': isDarkMode() }">
      <table class="mat-elevation-z8 printable-table" id="style-4" matSort (matSortChange)="sortData($event)">
        <thead class="sticky-header">
          <tr>
            <th>S.No</th>
            <th mat-sort-header="ship_name">Vessel Name</th>
            <th mat-sort-header="ship_imo">Vessel IMO</th>
            <th mat-sort-header="voyage_no">Voyage Number</th>
            <th>Heat Plan Number</th>
            <th>Reported Timestamp</th>
            <th>Report</th>
          </tr>
        </thead>

        <tbody>
          <ng-container *ngFor="let element of paginatedData; let rowIndex = index">
            <tr>
              <td>{{ (currentPage * itemsPerPage) + rowIndex + 1 }}</td>

              <td matTooltip="{{ element.ship_name }}">
                {{ element.ship_name?.length > 12 ? (element.ship_name | slice:0:12) + '...' : element.ship_name }}
              </td>

              <td matTooltip="{{ element.ship_imo }}">
                {{ element.ship_imo?.length > 12 ? (element.ship_imo | slice:0:12) + '...' : element.ship_imo }}
              </td>

              <td matTooltip="{{ element.voyage_no }}">
                {{ element.voyage_no?.length > 12 ? (element.voyage_no | slice:0:12) + '...' : element.voyage_no}}
              </td>

              <td matTooltip="{{ element.hp_np }}">
                {{ element.hp_np?.length > 12 ? (element.hp_np | slice:0:12) + '...' : element.hp_np }}
              </td>

              <td>{{ element.ingested_time | date:'dd/MM/yyyy HH:mm' }}</td>

              <td>
                <div class="dropdown-container">
                  <button #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="reportMenu" class="downloadIcon"
                    [class.loading]="element.isDownloading" [disabled]="element.isDownloading"
                    matTooltip="Select Report">
                    <mat-icon *ngIf="!element.isDownloading">arrow_drop_down</mat-icon>
                    <mat-icon *ngIf="element.isDownloading" class="spin-icon">sync</mat-icon>
                  </button>

                  <mat-menu #reportMenu="matMenu" class="report-menu modern-report-popup" xPosition="before">
                    <div class="menu-content">
                      <div class="menu-header" (click)="$event.stopPropagation()">
                        <div class="header-icon-badge">
                          <mat-icon>assessment</mat-icon>
                        </div>
                        <div class="header-titles">
                          <span class="menu-title">Select Report Type</span>
                          <span class="menu-subtitle">Voyage {{ element.voyage_no || '-' }} · HP #{{ element.hp_np ||
                            '-' }}</span>
                        </div>
                      </div>

                      <div class="report-options-list">
                        <button type="button" *ngFor="let report of reportOptions" class="report-item-btn"
                          (click)="onReportSelect(report.value, element); menuTrigger.closeMenu()">
                          <div class="item-icon-wrap" [style.background]="report.color + '20'"
                            [style.border-color]="report.color + '40'">
                            <mat-icon [style.color]="report.color">{{ report.icon }}</mat-icon>
                          </div>
                          <div class="item-text">
                            <span class="item-label">{{ report.label }}</span>
                            <span class="item-desc">{{ report.desc }}</span>
                          </div>
                          <div class="item-action">
                            <mat-icon class="download-action-icon">file_download</mat-icon>
                          </div>
                        </button>
                      </div>
                    </div>
                  </mat-menu>
                </div>
              </td>
            </tr>
          </ng-container>

          <tr *ngIf="!paginatedData.length">
            <td colspan="7" class="empty-state-cell">
              <div class="empty-state-wrap">
                <mat-icon class="empty-icon">inventory_2</mat-icon>
                <p class="empty-title">No heat plans found</p>
                <span class="empty-subtitle">Try adjusting your filters or date range</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Integrated Table Footer -->
    <div class="table-card-footer" [ngClass]="{ 'dark-footer': isDarkMode() }">
      <div class="footer-left">
        <span class="records-summary" *ngIf="elements.length > 0">
          Showing <span class="highlight">{{ getStartIndex() }}</span> to <span class="highlight">{{ getEndIndex()
            }}</span> of <span class="highlight">{{ elements.length }}</span> records
        </span>
        <span class="records-summary" *ngIf="elements.length === 0">
          No records found
        </span>
      </div>

      <div class="footer-right">
        <mat-paginator class="premium-paginator integrated-paginator" [length]="elements.length"
          [pageSize]="itemsPerPage" hidePageSize="true" (page)="onPageChange($event)"
          [ngClass]="{ 'dark-paginator': isDarkMode() }" showFirstLastButtons></mat-paginator>
      </div>
    </div>
  </div>

  <!-- Floating Modern Downloader Toast -->
  <div class="downloading-toast-card" *ngIf="downloadingKey">
    <div class="toast-spinner-box">
      <mat-icon class="pulse-icon">cloud_download</mat-icon>
    </div>
    <div class="toast-info">
      <span class="toast-title">Getting Report...</span>
      <span class="toast-desc">{{ downloadingReportName }}</span>
    </div>
    <div class="toast-progress-bar">
      <div class="progress-indeterminate"></div>
    </div>
  </div>
</div>